import { NotificationGroup } from '@progress/kendo-react-notification';
import SingleNotification from 'commons/container/SingleNotification';
import PropTypes from 'prop-types';
import React, { Fragment } from 'react';
import { useAppSelector } from '../../redux/store';

export default function ContainerContent(props) {
  const notification = useAppSelector(state => state.appState.notificationMessages);

  return (
    <Fragment>
      <div>{props.children}</div>
      <NotificationGroup
        style={{
          right: 0,
          bottom: 1,
          alignItems: 'flex-start',
          flexWrap: 'wrap-reverse',
        }}
      >
        {notification ?
          <SingleNotification
            text={notification.text}
            style={notification.style}
            timeout={notification.timeout}
          />
          : null}
      </NotificationGroup>
    </Fragment>
  );
}

ContainerContent.propTypes = {
  children: PropTypes.oneOfType([
    PropTypes.arrayOf(PropTypes.node),
    PropTypes.node,
  ]),
  notifications: PropTypes.arrayOf(
    PropTypes.shape({
      text: PropTypes.string.isRequired,
      style: PropTypes.string.isRequired,
      timeout: PropTypes.number.isRequired,
    })
  )
};
